// in src/App.js
import React from 'react';
import {Admin, Resource} from 'admin-on-rest';
import Login from './Login';
import authClient from './authClient';
import FuseLayout from './Fuse/admin/FuseLayout';
import {AppTitle} from './Fuse/global/title';
import {MainMenu} from './Fuse/global/menu';
import {FuseFooter} from './Fuse/global/footer';
import {
    fuseRestClient,
    fuseDashboard
} from './Fuse'
import NotFound from './Fuse/notFound';
import fuseReducer from './Fuse/admin/fuseReducer';
import fuseSaga from './Fuse/admin/fuseSaga';
import customRoutes from './routes';
import {resolveAccess} from './Fuse/shared/authFunctions';

import {
    viewScheduledReportEdit,
    viewScheduledReportShow
} from './Fuse/views/ScheduledReport';

import getMuiTheme from 'material-ui/styles/getMuiTheme';
import FuseTheme from './Fuse/global/theme';

const App = () => (
    <Admin title={<AppTitle/>}
           key="Admin"
           theme={getMuiTheme(FuseTheme)}
           appLayout={FuseLayout}
           dashboard={fuseDashboard}
           menu={MainMenu}
           restClient={fuseRestClient({})}
           loginPage={Login}
           customRoutes={customRoutes}
           customReducers={{fuseNotification: fuseReducer}}
           customSagas={[fuseSaga]}
           authClient={authClient}
           catchAll={NotFound}
           footer={FuseFooter}
    >
        {permissions => [
            // Scheduled Report Views
            resolveAccess(permissions, ['schedule_reports'])
                ? <Resource
                    name="ScheduledReports"
                    show={viewScheduledReportShow}
                    edit={viewScheduledReportEdit}
                    canEdit
                />
                : null,

            // Daily Sales Report Resources
            resolveAccess(permissions)
                ? <Resource name="TransactionsByDay" options={{label: 'Transactions by Day'}}/>
                : null,

            // Detailed Sales Report Resources
            resolveAccess(permissions)
                ? <Resource name="DetailedSales" options={{label: 'Sales Summary by Location and Date'}}/>
                : null,

            // Settlement Report Resources
            resolveAccess(permissions)
                ? <Resource name="ZeroDays" options={{label: 'Zero Days'}}/>
                : null,
            resolveAccess(permissions)
                ? <Resource name="FinalAuditsByZeroDay" options={{label: 'Final Audits by Zero Day'}}/>
                : null,
            resolveAccess(permissions)
                ? <Resource name="FinalAuditItems" options={{label: 'Final Audit Items'}}/>
                : null,
            resolveAccess(permissions)
                ? <Resource name="DefaultPricesByProductType"
                            options={{label: 'Default Prices by Location Product Type'}}/>
                : null,
            resolveAccess(permissions)
                ? <Resource name="SaleSummaryByZeroDay" options={{label: 'Sales Summary by Zero Day'}}/>
                : null,

            resolveAccess(permissions)
                ? <Resource name="Systems" options={{label: 'Systems'}}/>
                : null,
            resolveAccess(permissions)
                ? <Resource name="Locations" options={{label: 'Locations'}}/>
                : null
        ]}
    </Admin>
);

export default App;



// WEBPACK FOOTER //
// ./src/App.js